import moment from 'moment';

const ampmParser = (time) => {
  const splittedTimeValue = time?.split(':');
  const hours = splittedTimeValue?.[0];
  const intHours = hours && parseInt(hours);
  const mins = splittedTimeValue?.[1];
  const intMins = mins && parseInt(mins);
  const sec = splittedTimeValue?.[2];

  const parsedTime = `${hours}:${mins}`;

  // 00:00 - 11:59 - AM
  // 12:00 - 23:59 - PM

  if (intHours >= 0 && intHours < 12) {
    return `${parsedTime} AM`;
  } else if (intHours > 12 && intHours < 24) {
    return `${parsedTime} PM`;
  } else if (intHours === 12) {
    return `${parsedTime} PM`;
  } else {
    throw new Error('Invalid time format');
  }
};

const sortObject = (o) =>
  Object.keys(o)
    .sort()
    .reduce((r, k) => ((r[k] = o[k]), r), {});

export const transformAppointmentData = (data) => {
  const transformedDataList = [];

  let appointmentsList = data?.result?.availableAppointments || data?.result?.availableOptionalAppointments;

  if (!Object.keys(appointmentsList).length) {
    return [];
  }

  appointmentsList = sortObject(appointmentsList);
  Object.entries(appointmentsList).forEach(([key, value], index) => {
    const transformedData = {
      title: '',
      subtitle: '',
      value: key ? key : '',
      isSelected: false,
      slotList: []
    };

    const parsedAppointmentDate = new Date(key);
    const appointmentDate = moment(parsedAppointmentDate).format('DD');
    const appointmentDay = moment(parsedAppointmentDate).format('ddd');

    transformedData.title = appointmentDate;
    transformedData.subtitle = appointmentDay;
    transformedData.isSelected = index === 0 ? true : false;

    if (value?.length > 0) {
      value?.forEach((item, slotIndex) => {
        const timeSlot = {
          title: '',
          isSelected: false
        };

        const timeInterval = item?.timeInterval;
        const startTime = timeInterval?.start;
        const parsedStartTime = ampmParser(startTime);
        const endTime = timeInterval?.finish;
        const parsedEndTime = ampmParser(endTime);
        const parsedSlotValue = `${parsedStartTime} - ${parsedEndTime}`;

        timeSlot.title = parsedSlotValue;
        timeSlot.isSelected = slotIndex === 0 ? true : false;

        transformedData.slotList.push(timeSlot);
      });
    }

    transformedDataList.push(transformedData);
  });

  return transformedDataList;
};
